import { createCommand } from '@atlassian/rovo-content-bridge-api';
export var NotifySuccessCommand = createCommand('notify-success-command');